import { useTranslation } from "react-i18next";
import "./Theme.css";
import { VThemeTemplate } from "../../../../utils/data/ThemeTemplate";

interface ThemeCardProps {
  theme: VThemeTemplate;
  onApply: () => void;
  isSelected: boolean;
}

export const ThemeCard = ({ theme, onApply, isSelected }: ThemeCardProps) => {
  const { t } = useTranslation();
  return (
    <div
      onClick={onApply}
      className={`theme-card ${isSelected ? "selected" : ""} ${
        theme.isCamingSoon ? "coming-soon" : ""
      }`}
    >
      {theme.isCamingSoon ? (
        <div className="coming-soon-overlay">
          <div className="coming-soon-content">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <circle cx="12" cy="12" r="10" />
              <polyline points="12 6 12 12 16 14" />
            </svg>
            <span>Coming Soon</span>
          </div>
        </div>
      ) : (
        <>
          <div className="theme-preview">
            <img
              src={theme.displayWeb}
              alt={`${theme.name} web preview`}
              className="theme-image-web"
            />

            {isSelected && (
              <div className="selected-badge">
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                >
                  <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z" />
                </svg>
              </div>
            )}
          </div>
          <div
            className="preview-button"
            onClick={() => {
              window.open(theme.previewUrl, "_blank");
            }}
          >
            {t("common.preview")}
          </div>
        </>
      )}
    </div>
  );
};
